var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _vm.imageSoonDownloadable
              ? _c(
                  "div",
                  {
                    staticClass:
                      "alert alert-info span-width alert-dismissible",
                    attrs: { id: "data-alert", role: "alert" }
                  },
                  [
                    _c("strong", [_vm._v("Some data is pending!")]),
                    _vm._v(" It will show up in the table shortly.\n          ")
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto" }, [
            _c("a", { attrs: { href: _vm.archiveLink, target: "_blank" } }, [
              _vm._v("LCO Science Archive (this session's images)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { height: "300px", overflow: "auto" } }, [
          _c(
            "table",
            {
              staticClass: "table table-hover table-condensed",
              attrs: { id: "session-table" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sessionImages, function(image) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(image.targetName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.ra))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.dec))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.exposureTime))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.filterType))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.timestamp))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(image.imageType))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: image.downloadUrl,
                            "data-toggle": "tooltip",
                            title: "Download FITS file"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../img/ic_file_download_black_24px.svg")
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "hand" },
                          attrs: {
                            "data-toggle": "tooltip",
                            title: "Preview image in new tab"
                          },
                          on: {
                            click: function($event) {
                              return _vm.getLargeImage(image.id)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("../img/ic_image_24px.svg") }
                          })
                        ]
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "table-caption mb-1" }, [
        _vm._v("Session Images")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Target Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Right Ascension")]),
        _vm._v(" "),
        _c("th", [_vm._v("Declination")]),
        _vm._v(" "),
        _c("th", [_vm._v("Exposure Time (sec)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Filter")]),
        _vm._v(" "),
        _c("th", [_vm._v("Timestamp (UTC)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Image type")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }